import { render, staticRenderFns } from "./lineMallList.vue?vue&type=template&id=b441e7b8&scoped=true&"
import script from "./lineMallList.vue?vue&type=script&lang=js&"
export * from "./lineMallList.vue?vue&type=script&lang=js&"
import style0 from "./lineMallList.vue?vue&type=style&index=0&id=b441e7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b441e7b8",
  null
  
)

export default component.exports